<template>
  <div v-if="currentProfil.employe">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <b-card class="text-black" header-class="bg-silver" no-body>
            <template #header>
              <div>
                <h5 class="font-size-16 mb-0">
                  <i class="fa fa-id-card mr-0"></i> Etat civil
                </h5>
              </div>
            </template>
            <div class="row">
              <div class="col-md-12">
                <table class="table table-bordered mb-0">
                  <tbody>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold"> Nom : </span>
                          </div>
                          <div>
                            {{ currentProfil.employe.nom }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold"> Prénom : </span>
                          </div>
                          <div>
                            {{ currentProfil.employe.prenom }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold"> Matricule : </span>
                          </div>
                          <div>
                            {{ currentProfil.employe.matricule }}
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i class="fa fa-venus text-custom-primary"></i>
                            <span class="font-weight-bold"> Civilité : </span>
                          </div>
                          <div>
                            {{ currentProfil.employe.civilite.nom }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i class="far fa-calendar text-custom-primary"></i>
                            <span class="font-weight-bold">
                              Date de naissance :
                            </span>
                          </div>
                          <div>
                            {{ currentProfil.employe.date_naissance }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Lieu de naissance :
                            </span>
                          </div>
                          <div>
                            {{ currentProfil.employe.lieu_naissance }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Pays de naissance :
                            </span>
                          </div>
                          <div>
                            {{ currentProfil.employe.pays_naissance }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Nationalité :
                            </span>
                          </div>
                          <div>
                            {{ currentProfil.employe.nationalite }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i class="fa fa-phone text-custom-primary"></i>
                            <span class="font-weight-bold"> Téléphone : </span>
                          </div>
                          <div>
                            {{ currentProfil.employe.telephone }}
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i class="far fa-envelope text-custom-primary"></i>
                            <span class="font-weight-bold">
                              Email principal :
                            </span>
                          </div>
                          <div>
                            {{ currentProfil.employe.email_principal }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              N° sécurité sociale :
                            </span>
                          </div>
                          <div>
                            {{ currentProfil.employe.num_securite_sociale }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Code postal :
                            </span>
                          </div>
                          <div>
                            {{ currentProfil.employe.code_postal }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i class="fa fa-city text-custom-primary"></i>
                            <span class="font-weight-bold"> Ville : </span>
                          </div>
                          <div>
                            {{ currentProfil.employe.ville }}
                          </div>
                        </div>
                      </td>
                      <td colspan="2">
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="far fa-address-card text-custom-primary"
                            ></i>
                            <span class="font-weight-bold"> Adresse : </span>
                          </div>
                          <div v-html="currentProfil.employe.adresse"></div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-card>
        </div>
      </div>
      <div class="row mt-n4">
        <div class="col-md-12 col-lg-6">
          <b-card class="text-black" header-class="bg-silver" no-body>
            <template #header>
              <div>
                <h5 class="font-size-16 mb-0">
                  <i class="fa fa-cube mr-0"></i> Situation familiale
                </h5>
              </div>
            </template>
            <div class="row">
              <div class="col-md-12">
                <table class="table table-bordered mb-0">
                  <tbody>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Situation familiale :
                            </span>
                          </div>
                          <div>
                            {{
                              currentProfil.employe.situation_familiale
                                ? currentProfil.employe.situation_familiale.nom
                                : '###'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Lien de parenté avec l'employeur :
                            </span>
                          </div>
                          <div>
                            {{
                              currentProfil.employe.lien_parente_employeur
                                ? currentProfil.employe.lien_parente_employeur
                                    .nom
                                : '###'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Nombre d'adultes :
                            </span>
                          </div>
                          <div>
                            {{ currentProfil.employe.nombre_adulte }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Nombre d'enfants :
                            </span>
                          </div>
                          <div>
                            {{ currentProfil.employe.nombre_enfant }}
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-card>
        </div>
        <div class="col-md-12 col-lg-6">
          <b-card class="text-black" header-class="bg-silver" no-body>
            <template #header>
              <div>
                <h5 class="font-size-16 mb-0">
                  <i class="fa fa-cube mr-0"></i> En cas d'urgence
                </h5>
              </div>
            </template>
            <div class="row">
              <div class="col-md-12">
                <table class="table table-bordered mb-0">
                  <tbody>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold"> Nom : </span>
                          </div>
                          <div>
                            {{ currentProfil.employe.urgence_contact_nom }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i class="fa fa-phone text-custom-primary"></i>
                            <span class="font-weight-bold"> Téléphone : </span>
                          </div>
                          <div>
                            {{
                              currentProfil.employe.urgence_contact_telephone
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Lien de parenté :
                            </span>
                          </div>
                          <div>
                            {{
                              currentProfil.employe.lien_parente_employeur
                                ? currentProfil.employe.lien_parente_employeur
                                    .nom
                                : '###'
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-card>
        </div>
      </div>
      <div class="row mt-n4">
        <div class="col-md-12 col-lg-6">
          <b-card class="text-black" header-class="bg-silver" no-body>
            <template #header>
              <div>
                <h5 class="font-size-16 mb-0">
                  <i class="fa fa-cube mr-0"></i> Restriction médicale
                </h5>
              </div>
            </template>
            <div class="row">
              <div class="col-md-12">
                <table class="table table-bordered mb-0">
                  <tbody>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Restriction médicale :
                            </span>
                          </div>
                          <div>
                            {{ currentProfil.employe.restriction_medicale }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Maladies professionelles :
                            </span>
                          </div>
                          <div
                            v-html="
                              currentProfil.employe.maladie_professionnelle
                            "
                          ></div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-card>
        </div>
        <div class="col-md-12 col-lg-6">
          <b-card class="text-black" header-class="bg-silver" no-body>
            <template #header>
              <div>
                <h5 class="font-size-16 mb-0">
                  <i class="fa fa-cube mr-0"></i> Détails
                </h5>
              </div>
            </template>
            <div class="row">
              <div class="col-md-12">
                <table class="table table-bordered mb-0">
                  <tbody>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i class="far fa-calendar text-custom-primary"></i>
                            <span class="font-weight-bold">
                              Date de création :
                            </span>
                          </div>
                          <div class="text-primary">
                            {{
                              currentProfil.employe.created_at
                                | formatDate('DD/MM/YYYY HH:MM')
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i class="far fa-user text-custom-primary"></i>
                            <span class="font-weight-bold"> Auteur : </span>
                          </div>
                          <div class="text-primary">
                            <span v-if="currentProfil.employe.created_by">
                              {{
                                currentProfil.employe.created_by.prenom
                                  ? currentProfil.employe.created_by.prenom +
                                    ' ' +
                                    currentProfil.employe.created_by.nom
                                  : currentProfil.employe.created_by.nom
                              }}
                            </span>
                            <span v-else> ### </span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters('profilParticipant', ['currentProfil']),
  },
};
</script>

<style scoped>
.table td {
  vertical-align: middle;
  font-size: 16px;
}
.bg-silver {
  background-color: transparent;
  border-color: #ced4da;
}
</style>
